var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import MuiInputLabel from '@mui/material/InputLabel';
import { InfoCircleIcon } from '../../icons';
import Tooltip from '../Tooltip';
import IconButton from '@mui/material/IconButton';
var InputLabel = function (_a) {
    var labelTooltipText = _a.labelTooltipText, TooltipProps = _a.TooltipProps, props = __rest(_a, ["labelTooltipText", "TooltipProps"]);
    return (React.createElement("div", null,
        React.createElement(MuiInputLabel, __assign({}, props)),
        labelTooltipText ? (React.createElement(Tooltip, __assign({ title: labelTooltipText }, TooltipProps),
            React.createElement(IconButton, null,
                React.createElement(InfoCircleIcon, { fontSize: "inherit" })))) : ('')));
};
export default InputLabel;
//# sourceMappingURL=InputLabel.js.map